import React from 'react';
import {
  Stack,
  Heading,
  Text,
  List,
  ListItem,
  Strong,
  ChevronLink,
  Box,
} from '@origin-digital/ods-core';
import {
  IconElectricity,
  IconSmartphone,
  IconElectricCar,
  IconElectricMeter,
} from '@origin-digital/ods-icons';

export const EVModal = (
  <Stack space="xlarge">
    <Stack space={['medium', 'large']}>
      <img
        src="https://www.originenergy.com.au/cdn/images/originenergy/image/upload/icons/EV_Power_Up.svg"
        alt="Everyday Rewards"
        height="64px"
      />
      <Stack space="large">
        <Heading variant="h3">How we calculate this cost</Heading>
        <Text>
          $5 EV full charge estimate is based on a continuous electricity charge rate of 8c/kWh
          powering a Tesla Model Y or Tesla Model 3 with a useable 57.5 kWh battery. The estimated
          cost is $4.60 to charge a Tesla Model Y and Tesla Model 3 (RWD) from zero charge to full
          capacity with Origin EV Power Up.
        </Text>
        <Stack space="small">
          <Text weight="medium">More on EV charging with Origin EV Power Up</Text>
          <Text>
            Origin EV Power Up beta is our automated electric vehicle charging solution that unlocks
            a lean, EV-exclusive rate of 8c/kWh for scheduled charge sessions in the Origin app.
          </Text>
          <Text>
            All you have to do is complete the sign-up journey in the app and link your compatible
            EV. Then it’s as simple as plug in, set a time you need your EV charging to be completed
            by in the app and we’ll handle the rest.
          </Text>
        </Stack>
      </Stack>

      <List>
        <Text>All you need is:</Text>
        <ListItem icon={<IconElectricity />}>An Origin residential electricity plan*</ListItem>
        <ListItem icon={<IconElectricMeter />}>A smart meter</ListItem>
        <ListItem icon={<IconElectricCar />}>A compatible EV</ListItem>
        <ListItem icon={<IconSmartphone />}>The latest Origin app</ListItem>
      </List>
      <Text variant="body-small">*Excluding customers in an embedded network</Text>
    </Stack>
    <Box paddingY="large" paddingX="medium" backgroundColor="grey50" borderRadius="medium">
      <Stack space="medium">
        <Heading variant="h4">Important things to know</Heading>
        <Stack space="xsmall">
          <Text weight="medium">You're in control</Text>
          <Text>
            You have the flexibility to override your charge schedule with our Instant Charge
            feature, when you need to urgently charge your EV at your standard electricity rate.
          </Text>
        </Stack>
        <Stack space="xsmall">
          <Text>
            <Strong>Linking your account</Strong>
          </Text>
          <Text>
            If you choose the EV Power Up add-on, it won’t form part of any electricity plan you
            sign-up to today. By registering your interest here, you’ll receive an invitation to
            sign-up via Origin app and link your eligible EV. Once added to your electricity plan,
            EV Power Up will enable eligible scheduled EV charge sessions in the app to effectively
            be billed at a rate of 8c/kWh. Savings made via eligible scheduled charging with EV
            Power Up will be applied as a credit to your next electricity bill. Eligibility, Terms
            and Conditions apply.
          </Text>
        </Stack>
      </Stack>
    </Box>

    <ChevronLink href="/origin-loop/electric-vehicle-charging/ev-power-up/" target="_blank">
      Find out more about EV Power Up
    </ChevronLink>
  </Stack>
);
